import styled, { keyframes } from "styled-components";
import { fadeInLeft } from "react-animations";
const fadeAnimation = keyframes`${fadeInLeft}`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray};
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  animation: 0.5s ${fadeAnimation};
  overflow-y: auto;

  .headerBurguerMenu {
    display: flex;
    justify-content: flex-end;
    padding: 15px 15px 0 15px;
    color: ${({ theme }) => theme.colors.white};
  }

  .navBurguerUser {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .navBurguerUser > img {
    width: 200px;
    margin-bottom: 15px;
  }
  .navBurguerUser > p {
    color: white;
    margin-top: 5px;
    text-transform: capitalize;
    font-size: 1.5rem;
    text-align: center;
  }
  .navLinksContainer {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }

  .navBurguerLinks {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0 25px;
    margin: 10px auto;
  }
  .navBurguerLinks > p {
    color: white;
    margin-top: 15px;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    text-align: start;
    width: 100%;

    border-bottom: 1px solid white;
  }
  .navBurguerLinks > p::after {
    border-bottom: 1px solid white;
  }
  .navBurguerLinks > p > svg {
    margin-right: 10px;
  }
`;
